export default function mmas4Score(mmas4) {
  return mmas4.keySeq().reduce((sum, key) => {
    return keys.includes(key)
      ? sum += scoreForValue(mmas4.get(key))
      : sum;
  }, 0);
};

const keys = [
  'forget',
  'careless',
  'stopWhenWorse',
  'stopWhenBetter'
];
  
function scoreForValue(val) {
  return val ? 1 : 0;
}



// WEBPACK FOOTER //
// ./src/business-logic/mmas4-score.js